'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BibSeries(_ref) {
  var series = _ref.series;

  if (series && !series.isEmpty()) {
    var name = series.get('name');
    var volume = series.get('volume');
    return _react2.default.createElement(
      'span',
      { className: 'cp-bib-series' },
      _react2.default.createElement(
        _reactRouter.IndexLink,
        {
          activeClassName: 'active-search-link',
          to: { pathname: '/v2/search', query: { query: name, searchType: 'series' } } },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'seriesLabel', values: { name: name } })
      ),
      volume ? ' - ' + volume : null
    );
  }
  return null;
}

BibSeries.displayName = 'BibSeries';
BibSeries.propTypes = {
  series: _reactImmutableProptypes2.default.mapContains({
    name: _react.PropTypes.string,
    volumeNumber: _react.PropTypes.number
  })
};

exports.default = BibSeries;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-series/lib/components/BibSeries.component.js
// module id = 1472
// module chunks = 1